export const OTTO_THINKING_STATES = [
  "Chasing my tail",
  "Playing fetch",
  "Sniffing butts",
  "Digging a hole",
  "Zooming around the house",
  "Burying a bone",
  "Begging for treats",
  "Rolling in something suspicious",
  "Barking at the mailman",
  "Doing zoomies",
  "Herding the data",
  "Pawing at the door",
  "Chewing on a shoe",
  "Napping in a sunbeam",
  "Sniffing every blade of grass",
  "Howling at the moon",
  "Catching frisbees",
  "Shedding everywhere",
  "Stealing food off the table",
  "Spinning in circles before sitting",
  "Licking your face",
  "Scratching behind my ear",
  "Fetching the ball again",
  "Tilting my head curiously",
  "Whimpering at thunder",
  "Marking my territory",
  "Splashing in puddles",
  "Gnawing on a stick",
  "Eating homework",
  "Chasing squirrels",
  "Shaking off after a bath",
  "Learning a new trick",
  "Pawing at my food bowl",
  "Drooling on the carpet",
  "Snoring loudly",
  "Tearing up a pillow",
  "Playing dead",
  "Refusing to come inside",
  "Wagging furiously",
  "Getting tangled in the leash",
  "Flopping over for belly rubs",
  "Being a very good boy",
];

export const SUMMI_THINKING_STATES = [
  "Trumpeting a greeting",
  "Spraying water from my trunk",
  "Never forgetting",
  "Flapping my ears",
  "Rolling in the mud",
  "Picking peanuts with my trunk",
  "Leading the herd",
  "Remembering ancestors",
  "Stomping through the savannah",
  "Painting a masterpiece with my trunk",
  "Taking a dust bath",
  "Carrying a log",
  "Cooling off in the river",
  "Comforting a younger elephant",
  "Digging for salt",
  "Uprooting a shrub",
  "Recalling a face from decades ago",
  "Listening for distant rumbles",
  "Munching on acacia leaves",
  "Shading myself under a baobab",
  "Dusting my back",
  "Reaching for tall branches",
  "Recalling the way home",
  "Pondering the weight of time",
  "Tusking up some roots",
  "Swaying gently in place",
  "Greeting a family member",
  "Watching over the calves",
];

export const QUILL_THINKING_STATES = [
  "Rolling into a ball",
  "Foraging for insects",
  "Bristling my quills",
  "Snuffling through the leaves",
  "Curling up for a quick nap",
  "Running on my wheel",
  "Nibbling a mealworm",
  "Sniffing the air cautiously",
  "Anointing my quills",
  "Padding through the underbrush",
  "Building a nest of dry leaves",
  "Huffing at an intruder",
  "Poking my nose out",
  "Waddling across the path",
  "Licking something suspicious",
  "Hiding under a log",
  "Quilling up defensively",
  "Snorting softly",
  "Rearranging my quills",
  "Hunting slugs",
  "Exploring the garden",
  "Rolling over a pebble",
  "Twitching my whiskers",
  "Sniffing for worms",
  "Settling into a quiet corner",
  "Scurrying across the lawn",
  "Shuffling through dewy grass",
];

export const SAGE_THINKING_STATES = [
  "Plodding along",
  "Retracting into my shell",
  "Chewing a leafy green",
  "Basking in the sun",
  "Considering my next step",
  "Sniffing a dandelion",
  "Pondering existence",
  "Stretching a leg out",
  "Munching on lettuce",
  "Reaching for a strawberry",
  "Napping in the shade",
  "Navigating slowly but surely",
  "Contemplating the universe",
  "Digging a shallow burrow",
  "Outliving another generation",
  "Remembering the old ways",
  "Climbing a small rock",
  "Slowly blinking",
  "Tasting an unfamiliar plant",
  "Nestling into warm soil",
  "Watching the clouds drift by",
  "Reflecting on a long life",
  "Nodding sagely",
  "Pacing myself",
  "Taking the scenic route",
  "Yawning at the horizon",
  "Gathering my thoughts, slowly",
];

export const THINKING_STATES_BY_COMPANION: Record<string, string[]> =
  {
    otto: OTTO_THINKING_STATES,
    summi: SUMMI_THINKING_STATES,
    quill: QUILL_THINKING_STATES,
    sage: SAGE_THINKING_STATES,
  };
